import { CnpjUtils } from '../utils/cnpj-utils';

export class CpfCnpj {
  public static clearMask(value): string {
    return value ? CnpjUtils.sanitize(value) : undefined;
  }

  public static formatWithMask(value) {
    const document = this.clearMask(value);
    if (document) {
      switch (document.length) {
        case 11:
          return `${document.substring(0, 3)}.${document.substring(
            3,
            6
          )}.${document.substring(6, 9)}-${document.substring(9)}`;
        case 14:
          return CnpjUtils.formatWithMaskOrDefault(document) || document;
        default:
          return document;
      }
    }
    return undefined;
  }
}
